import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		edit: {
			panel: {
				maxHeight: '650px',
				minWidth: '50%',
				modal: true
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '70%',
				height: '500px'
			},
			config: {
				fields: {
					name: {}
				}
			}
		}
	}
}